export const getCognitoKeys = () =>
  Object.keys(localStorage).reduce(
    (acc, key) => (key.startsWith('CognitoIdentityServiceProvider') ? [...acc, key] : acc),
    [],
  )

export const clearCognitoKeys = () => getCognitoKeys().forEach(key => localStorage.removeItem(key))
